// export default ProductMap = {
exports.ProductMap = {
  3: {
    '2kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946294984777',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4099',
      old_price: '4497',
      save_money: '398',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946295017545',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4499',
      old_price: '5035',
      save_money: '536',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946295050313',
      adaptBatCap: 2,
      limit: 2,
      off_price: '4839',
      old_price: '5453',
      save_money: '614',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320314441',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5799',
      old_price: '6496',
      save_money: '697',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320347209',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6199',
      old_price: '7073',
      save_money: '874',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320379977',
      adaptBatCap: 2,
      limit: 1,
      off_price: '6539',
      old_price: '7491',
      save_money: '952',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322247753',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6499',
      old_price: '7097',
      save_money: '598',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322280521',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '6899',
      old_price: '7635',
      save_money: '736',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322313289',
      adaptBatCap: 5,
      limit: 2,
      off_price: '7239',
      old_price: '8053',
      save_money: '814',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340499529',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '9999',
      old_price: '11696',
      save_money: '1697',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340532297',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '10399',
      old_price: '12273',
      save_money: '1874',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340565065',
      adaptBatCap: 5,
      limit: 1,
      off_price: '10739',
      old_price: '12691',
      save_money: '1952',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344562761',
      consoleChoose: 'Y',
      off_price: '13499',
      old_price: '16295',
      save_money: '2796',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344595529',
      consoleChoose: 'Y',
      off_price: '13899',
      old_price: '16911',
      save_money: '3012',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Straps'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344628297',
      off_price: '14239',
      old_price: '17329',
      save_money: '3090',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Straps'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  3: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '6761262973001',
    varId: '39962928152649',
    old_price: '219',
    off_price: '219',
    // save_money: '0',
    limit: 99,
    // discount: "%1=229%%2=449%%3=649%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '6761270444105',
    varId: '39962923532361',
    old_price: '739',
    off_price: '739',
    // save_money: '0',
    limit: 99,
    tips: '*This item excludes free shipping.',
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexible Solar Panel',
    pid: '6761895231561',
    varId: '39962853343305',
    old_price: '199',
    off_price: '199',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }, {
    name: '1*400W Portable Solar Panel',
    pid: '6618094960713',
    varId: '39998021697609',
    old_price: '1199',
    off_price: '1199',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  3: [{
    name: '2kWh LFP Battery',
    pid: '6761212510281',
    varId: '39958505095241',
    off_price: '1999',
    old_price: '1999',
    // save_money: '0',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery',
    pid: '6761212510281',
    varId: '39958505128009',
    off_price: '4599',
    old_price: '4599',
    // save_money: '0',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  3: {
    pid: '6776213012553',
    varId: '40019530055753',
    off_price: '0',
    old_price: '0',
    save_money: '0'
  }
};
exports.ConsoleMap = {
  3: [{
    name: 'EcoFlow Power Kits Console',
    pid: '6788705878089',
    varId: '40062543495241',
    off_price: '349',
    old_price: '349',
    limit: 1,
    // save_money: '599',
    // beDepNodeName: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};

// exports.SmartGenerator = {
//     "3": [
//         {
//             name: "Smart Generator with Smart Generator Adapter",
//             pid: "6797293715529",
//             varId: "40086547759177",
//             off_price: '1300',
//             old_price: '1468',
//             limit: 99,
//             save_money: '168',
//             // depNodeName: 'console',
//             imgSrc: "/img/calculators/mm100/combo-generator.jpg"
//         }
//     ]
// }

exports.ShopifyUrl = 'https://us.ecoflow.com/';